
import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class PageHeader extends Vue {
  @Prop({ type: String, default: null }) readonly title!: string | null;
  @Prop({ type: String, default: null }) readonly description!: string | null;
}
